import type { LocalDate } from "@js-joda/core";
import { DateTimeFormatter } from "@js-joda/core";
import { EnumDateFormat } from "@/app/services/generated/enums/enumDateFormat.generated";

const dateFormatToString = (dateFormat: EnumDateFormat) => {
  if (EnumDateFormat.yYYYMMDD === dateFormat) {
    return "yyyy/MM/dd";
  }
  if (EnumDateFormat.dDMMYYYY === dateFormat) {
    return "dd/MM/yyyy";
  }
  if (EnumDateFormat.dDMMYY === dateFormat) {
    return "dd/MM/yy";
  }
  if (EnumDateFormat.mMDDYYYY === dateFormat) {
    return "MM/dd/yyyy";
  }
  if (EnumDateFormat.mMDDYY === dateFormat) {
    return "MM/dd/yy";
  } else {
    throw new Error("EnumDateFormat has invalid value " + dateFormat.value);
  }
};

const formatter = (dateFormat: EnumDateFormat) =>
  DateTimeFormatter.ofPattern(dateFormatToString(dateFormat));

const formatDate = (date: LocalDate, dateFormat: EnumDateFormat) =>
  formatter(dateFormat).format(date);

const dateTimes = {
  formatter,
  formatDate,
};

export { dateTimes };
